export default {
  superDesktop: 'Reportes',
  home: 'Inicio',
  people: 'Contactos',
  directory: 'CRM',
  lists: 'Listas',
  roles: 'Roles',
  segments: 'Segmentos',
  businesses: 'Compañías',
  talk: 'Inbox',
  chats: 'Chats',
  conversationMetrics: 'Métricas',
  conversationSettings: 'Configurar chats',
  emailSettings: 'Configurar emails',
  communicate: 'Comunica',
  campaigns: 'Campañas',
  triggers: 'Disparadores',
  notifications: 'Notificaciones',
  connect: 'Conecta',
  authenticator: 'Autenticador',
  forms: 'Formularios',
  oAuths: 'Oauths',
  crm: 'CRM',
  /* events */
  events: 'Eventos',
  myEvents: 'Mis Eventos',
  categories: 'Categorias',
  assistants: 'Asistentes',
  promotors: 'Promotores',
  djs: 'Djs',
  productsCategories: 'Categorías de Productos',
  products: 'Productos',
  places: 'Lugares',
  productsSales: 'Productos Vendidos',
  /* ORDERS */
  clients: 'Clientes',
  colors: 'Colores',
  containerTypes: 'Tipos de Contenedores',
  purchases: 'Compras',
  sellers: 'Vendedores',
  suppliers: 'Proveedores',
  /* microsites */
  microSites: 'Micrositios',
  configure: 'Configura',
  generalities: 'Generales',
  apps: 'Aplicativos',
  administrators: 'Administradores',
  billing: 'Facturación',
  graphicAspect: 'Aspecto Gráfico',
  automate: 'Automatiza',
  following: 'Seguimiento',
  mainTables: 'Maestros',
  panel: 'Panel',
  journeyLeads: 'Personas por journey',
  sequences: 'Secuencias',
  userConfiguration: 'Configuración del usuario'
}
